module.exports = __webpack_public_path__ + "public/SiteImages/createListBg.svg?4374f236";